import { assignJob, getFreePopulation, MAX_SMITHS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireSmithAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.blacksmith.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_SMITHS * settlement.buildings.blacksmith.qty;
    if (settlement.jobs.smiths >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'smiths')) return false;
    settlement.production.blacksmith.progress.push(0);
    settlement.production.blacksmith.task.push('tool');
    return true;
};
